"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookParserError = void 0;
const react_1 = __importDefault(require("react"));
class NeverError extends Error {
    constructor(value) {
        super(`Unexpected value: ${value}`);
    }
}
class BookParserError extends Error {
    constructor(errorDetails) {
        const errors = errorDetails
            .filter((_, i) => i < 100)
            .map((detail) => {
            if (detail.type === "TextColumnNotFound") {
                return `シート「${detail.sheetName}」に翻訳前テキスト列が見つかりませんでした。`;
            }
            if (detail.type === "DuplicatedID") {
                return `IDが重複しています (${detail.rows.map((row) => `${row.sheetName}の${row.rowIndex + 1}行目`).join(", ")})。`;
            }
            if (detail.type === "EmptyID") {
                return `IDが空です (${detail.sheetName}の${detail.rowIndex + 1}行目)。`;
            }
            if (detail.type === "ProhibitedCharacterInID") {
                return `IDに禁止文字が含まれています (${detail.sheetName}の${detail.rowIndex + 1}行目, ID=${detail.invalidId}, 禁止文字=${detail.prohibitedCharacters.join(",")})。`;
            }
            throw new NeverError(detail);
        });
        super(`ファイル解析に問題が発生しました。 ${errors.join("")}`);
        this.errorDetails = errorDetails;
        this.errors = errors;
    }
    render() {
        return (react_1.default.createElement(react_1.default.Fragment, null, this.errors.length > 0 && (react_1.default.createElement("p", { className: "text-danger", style: { fontSize: "0.875em" } },
            this.errors.slice(0, 5).map((error, index) => (react_1.default.createElement("div", { key: index }, error))),
            this.errors.length > 5 && (react_1.default.createElement("div", null,
                "+",
                this.errors.length - 5,
                " \u4EF6\u306E\u30A8\u30E9\u30FC\u304C\u3042\u308A\u307E\u3059"))))));
    }
}
exports.BookParserError = BookParserError;
